import React, { useState, useEffect, useCallback } from 'react';
import constClass from '../../Constants/Constants';
import Common from '../Common/common';
//import moment from 'moment';
import axios from 'axios';
import moment from 'moment';
import QRCode from "react-qr-code";
import QrImg from '../Images/qr-code.svg';
import Loading from '../Loading/Loading';

const TicketIssue = ({ ticket, backClick, disabled, liffAccessToken, siteId, mallId, setting, preview, couponPreview, ticketButtonClick }) => {

  const [qrData, setQrData] = useState(null);
  const [restTime, setRestTime] = useState(0);
  const [validTime, setValidTime] = useState(moment());

  const getQrData = useCallback(async () => {
    const qr_data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/line/ticket_issue/qrdata/${siteId}/`, { site_id: siteId, line_id: liffAccessToken, ticket_id: ticket.ticket_id, issue_count: ticket.issue_count, mall_id: mallId })).data;
    setQrData(qr_data);
    const date = moment();
    setValidTime(date + setting.COUPON_QRCODE_VALID_TIME * 60 * 1000);
  }, [siteId, liffAccessToken, setting, ticket.ticket_id, ticket.issue_count, mallId]);

  useEffect(() => {
    if (!preview) {
      getQrData();
    }
  }, [preview, getQrData]);

  useEffect(() => {
    if (!preview) {
      const intervalId = setInterval(() => {
        const date = moment();
        const sec = Math.floor((validTime - date) / 1000);
        setRestTime(sec);
        if (sec <= 0) {
          getQrData();
        }
      }, 1000);

      return () => {
        clearInterval(intervalId);
      };
    }
  }, [validTime, preview, getQrData]);

  return (
    <div id="ticketUse" className="ticket-use">
      {ticket.button_ticket_flag !== constClass.FLAG.ON && !preview && (qrData === null || restTime === 0) ? (
        <Loading />
      ) : (
        <React.Fragment>
          {ticket.button_ticket_flag !== constClass.FLAG.ON && !preview && setting.MEMBER_CARD_CODE_TYPE === '2' && qrData !== null && (
            <div className="frame13 mb-3">
              <React.Fragment>
                <span className="qrcode-rest mx-2">二次元コードの有効時間</span>
                <span className="qrcode-resttime">{restTime}</span>
                <span className="qrcode-time">秒</span>
              </React.Fragment>
            </div>
          )}
          <div className="ticket-detail-use">
            <div className="group13">
              <div className="frame50">
                {ticket.ticket_type === constClass.FLAG.ON &&
                  <div className={`${mallId === "1" ? "cardblank-one" :
                    mallId === "2" ? "cardblank-solaria" :
                      mallId === "3" ? "cardblank-stage" :
                        mallId === "4" ? "cardblank-chacha" :
                          mallId === "5" ? "cardblank-ohashi" :
                            mallId === "6" ? "cardblank-kurume" : ""
                    }`}>
                    {mallId === "1" && (
                      <React.Fragment>
                        <div className="card-name-one mt-2">
                          ONE
                        </div>
                        <div className="card-name-one mt-2">
                          FUKUOKA
                        </div>
                        <div className="card-name-one mt-2">
                          BLDG.
                        </div>
                      </React.Fragment>
                    )}
                    {mallId === "2" && (
                      <React.Fragment>
                        <div className="card-name-solaria mt-4">
                          SOLARIA
                        </div>
                        <div className="card-name-solaria mt-3">
                          PLAZA
                        </div>
                      </React.Fragment>)
                    }
                    {mallId === "3" && (
                      <React.Fragment>
                        <div className="card-name-stage mt-4">
                          SOLARIA
                        </div>
                        <div className="card-name-stage mt-3">
                          STAGE
                        </div>
                      </React.Fragment>)
                    }
                    {mallId === "4" && (
                      <React.Fragment>
                        <div className="card-name-chacha mt-4">
                          CHACHA
                        </div>
                        <div className="card-name-chacha mt-3">
                          TOWN
                        </div>
                      </React.Fragment>)
                    }
                    {mallId === "5" && (
                      <React.Fragment>
                        <div className="card-name-ohashi mt-4">
                          RAIRIA
                        </div>
                        <div className="card-name-ohashi mt-3">
                          OHASHI
                        </div>
                      </React.Fragment>)
                    }
                    {mallId === "6" && (
                      <React.Fragment>
                        <div className="card-name-kurume mt-4">
                          RAIRIA
                        </div>
                        <div className="card-name-kurume mt-3">
                          KURUME
                        </div>
                      </React.Fragment>)
                    }
                    <div className="frame4blank">
                      <div className='logoblank'>
                        {mallId !== "4" && <img src={`/${siteId}/logo.svg`} alt={'ロゴ'} />}
                        {mallId === "4" && <img src={`/${siteId}/logo2.svg`} alt={'ロゴ'} />}
                      </div>
                      <div className="ellipse1">
                      </div>
                      <div className="ellipse2">
                      </div>
                      <div className="ellipse3">
                      </div>
                    </div>
                  </div>
                }
                {ticket.ticket_type !== constClass.FLAG.ON && ticket.ticket_detail_image_url && ticket.ticket_image_url && <img className="ticket-detail-image" src={`/${siteId}/${constClass.TICKET_DETAIL_IMAGE_DIR}${ticket.ticket_detail_image_url}`} alt={ticket.ticket_name} style={{ objectFit: 'cover' }} />}
                {ticket.ticket_type !== constClass.FLAG.ON && !ticket.ticket_detail_image_url && ticket.ticket_image_url && <img className="ticket-detail-image" src={`/${siteId}/${constClass.TICKET_IMAGE_DIR}${ticket.ticket_image_url}`} alt={ticket.ticket_name} style={{ objectFit: 'cover' }} />}
                {ticket.ticket_type !== constClass.FLAG.ON && !ticket.ticket_detail_image_url && !ticket.ticket_image_url && <img className="ticket-detail-image" src={`/${siteId}/nodetailimage.png`} alt="nodetailimage" style={{ objectFit: 'cover' }} />}
                {ticket.button_ticket_flag === constClass.FLAG.ON &&
                  <div className="buttonticketframe49">
                    <div className="ticket-detail-text">{Common.getBrString(ticket.ticket_detail)}</div>
                  </div>
                }
                {ticket.button_ticket_flag !== constClass.FLAG.ON &&
                  <div className="group10">
                    <div className="ellipse12">
                      {(!ticket.use_date && ticket.invalid_flag !== constClass.FLAG.ON) && (
                        <React.Fragment>
                          {qrData && (
                            <div className="qr-box">
                              <QRCode className="qr-detail-img" size={100} value={qrData} />
                            </div>
                          )}
                          {!qrData && (
                            <div className="qr-preview">
                              <img className="qr-detail-img" src={QrImg} size={500} alt={"QRコード"} />
                            </div>
                          )}
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                }
                {ticket.button_ticket_flag !== constClass.FLAG.ON &&
                  <div className="frame49">
                    <div className="ticket-detail-text">{Common.getBrString(ticket.ticket_detail)}</div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div className="frame54">
            {ticket.button_ticket_flag === constClass.FLAG.ON &&
              <React.Fragment>
                <div className="text-center">
                  <div className="button-ticketuse-text">
                    この画面を店舗スタッフへご提示ください。
                  </div>
                  <div className="button-ticketuse-text">
                    以下のボタンは店舗用です。
                  </div>
                  <div className="button-ticketuse-text">
                    タップすると特典を利用します。
                  </div>
                  <button
                    disabled={disabled}
                    className="button-ticketuse text-white"
                    onClick={ticketButtonClick(ticket.issue_count, ticket.ticket_id)}>
                    使用する
                  </button>
                </div>
                <div className='vector17'></div>
              </React.Fragment>
            }
            {ticket.button_ticket_flag !== constClass.FLAG.ON && ticket.ticket_type === constClass.FLAG.OFF && ticket.ticket_times > 1 && ticket.ticket_times - ticket.t_ticket_use.length > 1 && (
              <React.Fragment>
                <div className="frame11">
                  <div className="points-held">
                    利用可能回数
                  </div>
                  <div className="frame9">
                    <div className="points">
                      {ticket.ticket_times - ticket.t_ticket_use.length}
                      <span className="count-text ml-2">回</span>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            )}
            {ticket.button_ticket_flag !== constClass.FLAG.ON &&ticket.ticket_type === constClass.FLAG.ON && ticket.use_point && (
              <React.Fragment>
                <div className="frame11">
                  <div className="points-held">
                    利用ポイント
                  </div>
                  <div className="frame9">
                    <div className="points">
                      {ticket.use_point}pt
                    </div>
                  </div>
                </div>
              </React.Fragment>
            )}
            {ticket.ticket_notes &&
              <React.Fragment>
                {((ticket.ticket_type === constClass.FLAG.OFF && ticket.ticket_times > 1 && ticket.ticket_times - ticket.t_ticket_use.length > 1) || (ticket.ticket_type === constClass.FLAG.ON && ticket.use_point)) && <div className="vector15"></div>}
                <div className="frame53">
                  <div className="ticket_notes mb-2">注意事項</div>
                  <div className="frame52">
                    {Common.getBrString(ticket.ticket_notes)}
                  </div>
                </div>
                {ticket.ticket_type === constClass.FLAG.OFF && ticket.limit_date !== '9999-12-31' && <div className="vector15"></div>}
              </React.Fragment>
            }
            {ticket.ticket_type === constClass.FLAG.OFF && ticket.limit_date !== '9999-12-31' &&
              <React.Fragment>
                {(!ticket.ticket_notes && (ticket.ticket_type === constClass.FLAG.OFF && ticket.ticket_times > 1 && ticket.ticket_times - ticket.t_ticket_use.length > 1)) && (<div className="vector15"></div>)}
                <div className="frame59">
                  <div className="ticket_notes mb-2">有効期限</div>
                  <div className="frame56">
                    {Common.getDateObject1(ticket.limit_date).str}
                  </div>
                </div>
              </React.Fragment>
            }
            {!couponPreview &&
              <div className="text-center">
                <button
                  disabled={disabled}
                  className="button text-black bg-lightwhite buckbutton"
                  onClick={backClick}>
                  戻る
                </button>
              </div>
            }
          </div>
        </React.Fragment>
      )}
    </div>
  )
}

export default TicketIssue;